import React from 'react';
import { TypographySmall } from '@/Components/shadcn';
import { RHFInput } from '@/Components/shadcn/rhf-input';
import UIStrings from '@/Utils/UIStrings';
import EmailTemplatePlaceholders from '../../EmailTemplatePlaceholders';
import { useCompanyContext } from '@/Context/CompanyContext';
import InfoTooltip from '@/Components/Tooltip/InfoTooltip';

interface SalutationProps {
    thankYouMessage: string;
}

const Salutation = ({ thankYouMessage }: SalutationProps) => {
    const { currentCompanyProfile } = useCompanyContext();
    const thankYouFullMessage = thankYouMessage.replace(
        EmailTemplatePlaceholders.CompanyName,
        currentCompanyProfile.companyName,
    );

    return (
        <>
            <div className="flex flex-row items-center justify-start gap-1">
                <div className="flex flex-row items-center justify-start gap-2">
                    <RHFInput fieldClassName="w-28" name="title" />
                    <TypographySmall className="whitespace-nowrap">{`${UIStrings.ApplicantsNamePlaceholder},`}</TypographySmall>
                </div>
                <InfoTooltip description={UIStrings.ApplicantNameTooltip} side="right" size="icon-xs" />
            </div>
            <TypographySmall className="pl-2">{thankYouFullMessage}</TypographySmall>
        </>
    );
};

export default Salutation;
